import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
const ADMIN_API = `${BASE}/api/admin`;

const getToken = () => localStorage.getItem('hh_admin_token');

const adminAxios = axios.create({ baseURL: ADMIN_API });
adminAxios.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const adminLogin = (username, password) =>
  adminAxios.post('/login', { username, password }).then((r) => r.data);

export const adminMe = () => adminAxios.get('/me').then((r) => r.data);

export const adminStats = () => adminAxios.get('/stats').then((r) => r.data);

export const adminSyncCatalog = () =>
  adminAxios.post('/sync-catalog').then((r) => r.data);

export const adminAnalytics = (days = 30) =>
  adminAxios.get('/analytics', { params: { days } }).then((r) => r.data);

// Products (use public endpoint for listing; admin endpoints for write)
export const adminCreateProduct = (data) =>
  adminAxios.post('/products', data).then((r) => r.data);
export const adminUpdateProduct = (id, data) =>
  adminAxios.put(`/products/${id}`, data).then((r) => r.data);
export const adminDeleteProduct = (id) =>
  adminAxios.delete(`/products/${id}`).then((r) => r.data);

// News
export const adminCreateNews = (data) =>
  adminAxios.post('/news', data).then((r) => r.data);
export const adminUpdateNews = (id, data) =>
  adminAxios.put(`/news/${id}`, data).then((r) => r.data);
export const adminDeleteNews = (id) =>
  adminAxios.delete(`/news/${id}`).then((r) => r.data);

// Orders
export const adminListOrders = () =>
  adminAxios.get('/orders').then((r) => r.data);
export const adminUpdateOrderStage = (orderId, stage) =>
  adminAxios.patch(`/orders/${orderId}`, { stage }).then((r) => r.data);

export const adminDeleteOrder = (orderId) =>
  adminAxios.delete(`/orders/${orderId}`).then((r) => r.data);

// Contacts
export const adminListContacts = () =>
  adminAxios.get('/contacts').then((r) => r.data);
export const adminDeleteContact = (id) =>
  adminAxios.delete(`/contacts/${id}`).then((r) => r.data);

// Site settings
export const adminUpdateSettings = (payload) =>
  adminAxios.put('/settings', payload).then((r) => r.data);
